module.exports = __webpack_public_path__ + "static/media/104bodies.62075630.gif";